import type { ComponentProps, JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system/layout';
import { buttonResetStyles } from '@change-corgi/design-system/reset';
import { Text } from '@change-corgi/design-system/typography';

import type { PartialComment as PartialCommentForReport } from 'src/app/shared/components/abuse';
import { ReportAbuseLink } from 'src/app/shared/components/abuse';

import type { PartialComment } from './hooks/useCommentReportAbuse';
import { useCommentReportAbuse } from './hooks/useCommentReportAbuse';

type Props = {
	comment: PartialCommentForReport & PartialComment;
	petition: {
		id: string;
		slug: string;
	};
	size?: ComponentProps<typeof Text>['size'];
};

export function CommentReportAbuse({
	comment,
	petition,
	size,
	...rest
}: Props & ComponentProps<typeof Flex>): JSX.Element {
	const {
		data: { a11yLabel },
	} = useCommentReportAbuse(comment);

	return (
		<Flex sx={{ alignItems: 'center' }} {...rest}>
			<ReportAbuseLink type="comment" comment={comment} petitionId={petition.id} petitionSlug={petition.slug}>
				<button type="button" sx={buttonResetStyles} aria-label={a11yLabel}>
					<Text as="div" size={size} color="inherit">
						<Translate value="fe.components.comments.report" />
					</Text>
				</button>
			</ReportAbuseLink>
		</Flex>
	);
}
